var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asc__carouselSlider" },
    [
      _c(
        "hooper",
        { attrs: { settings: _vm.hooperSettings } },
        [
          _vm._l(_vm.item, function(slider, i) {
            return _c(
              "slide",
              {
                key: "slider" + i,
                staticClass: "slide selfservice__slider",
                style: { backgroundImage: "url(" + slider.photo + ")" },
                attrs: { index: "slider" + i }
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", {
                        staticClass: "selfservice__sliderhome__text",
                        domProps: { innerHTML: _vm._s(slider.code) }
                      })
                    ])
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("hooper-navigation", {
            attrs: { slot: "hooper-addons" },
            slot: "hooper-addons"
          }),
          _vm._v(" "),
          _c("hooper-pagination", {
            attrs: { slot: "hooper-addons" },
            slot: "hooper-addons"
          }),
          _vm._v(" "),
          _c("hooper-progress", {
            attrs: { slot: "hooper-addons" },
            slot: "hooper-addons"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3565ce0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3565ce0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = null
// module chunks = 